import React from 'react';

import { Typography } from '@mui/material';
import clsx from 'clsx';
import { AlineAvatar } from 'src/components';
import type { Apollo } from 'src/gql/generated';
import { getRoleDisplayDetails } from 'src/helpers';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    width: '100%',
  },
}));

interface UserDefinedRoleMenuProps extends React.HTMLAttributes<HTMLElement> {
  userDefinedRole: Pick<Apollo.UserDefinedRole, '__typename' | 'id' | 'roleName'>;
}

export function AssignRolePlaceholder({
  className,
  userDefinedRole,
}: UserDefinedRoleMenuProps): JSX.Element {
  const { classes } = useStyles();
  const { avatarColor, primaryText } = getRoleDisplayDetails(userDefinedRole);

  return (
    <div className={clsx(classes.container, className)}>
      <AlineAvatar
        avatarInfo={userDefinedRole}
        styles={{ backgroundColor: avatarColor, size: 'md' }}
      />
      <Typography variant="body1">{primaryText}</Typography>
    </div>
  );
}
